import { render } from "./home.vue?vue&type=template&id=56fb2c72&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=56fb2c72&lang=scss&scoped=true"
import "./home.vue?vue&type=style&index=1&id=56fb2c72&lang=scss"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fb2c72"]])

export default __exports__